module.exports = __WEBPACK_EXTERNAL_MODULE_chartjs_plugin_datalabels_94b90fda__;